<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs3>
              <v-autocomplete
                :items="acctTypeList"
                :label="treatyInfo2Label.riType"
                v-model="treatyInfo2.riType"
                item-text="label"
                item-value="value"
                data-vv-name="riType"
                :data-vv-as="treatyInfo2Label.riType"
                :error-messages="errors.collect('riType')"
                v-validate="'entry'"
                disabled
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                :label="treatyInfo2Label.ttyNo"
                v-model="treatyInfo2.ttyNo"
                item-text="label"
                item-value="value"
                data-vv-name="ttyNo"
                :data-vv-as="treatyInfo2Label.ttyNo"
                :error-messages="errors.collect('ttyNo')"
                v-validate="'entry'"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="treatyInfo2Label.uwYr"
                v-model="treatyInfo2.uwYr"
                item-text="label"
                item-value="value"
                data-vv-name="uwYr"
                :data-vv-as="treatyInfo2Label.uwYr"
                :error-messages="errors.collect('uwYr')"
                v-validate="'entry'"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-title>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class=" mr-2" @click="doNew">
                {{ treatyInfo2Label.newButton }}
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
              <v-flex xs12>
                <message :messages="messages"></message>
              </v-flex>
            </v-card-title>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="name"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td class="text-xs-left">{{ row.item.riTypeDesc }}</td>
                    <td class="text-xs-left">{{ row.item.ttyNo }}</td>
                    <td class="text-xs-left">{{ row.item.dispSeq }}</td>
                    <td class="text-xs-left">{{ row.item.infoTxt }}</td>
                    <td class="table-action-header">
                      <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                    </td></tr
                ></template>
              </v-data-table>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-card>
      <!-- <v-layout row wrap>
      <v-flex xs12>
      <v-expansion-panel :value="miscTreatyInfo2Panel" expand>
        <v-expansion-panel-content>
          <div slot="header">
            <v-icon>mdi-plus</v-icon>
            {{ newMode ? 'New Miscellaneous Treaty Information 2':'Edit Miscellaneous Treaty Information 2' }}
          </div>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon v-if="newMode">mdi-plus</v-icon>
            <v-icon v-else>mdi-pencil</v-icon>
            <v-toolbar-title v-if="newMode">Create New Miscellaneous Treaty Information 2</v-toolbar-title>
            <v-toolbar-title v-else>Edit Miscellaneous Treaty Information 2</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-autocomplete :items="acctTypeList" :label="treatyInfo2Label.riType" v-model="treatyInfo2.riType" item-text="label" item-value="value" data-vv-name="riType" :data-vv-as="treatyInfo2Label.riType" :error-messages="errors.collect('riType')" v-validate="'entry'" @change="initInfoLblList" :disabled="this.newMode === false"></v-autocomplete>
                </v-flex>
                <v-flex xs3>
                  <v-text-field :label="treatyInfo2Label.ttyNo" v-model="treatyInfo2.ttyNo" item-text="label" item-value="value" data-vv-name="ttyNo" :data-vv-as="treatyInfo2Label.ttyNo" :error-messages="errors.collect('ttyNo')" v-validate="'entry'" readonly></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field :label="treatyInfo2Label.uwYr" v-model="treatyInfo2.uwYr" item-text="label" item-value="value" data-vv-name="uwYr" :data-vv-as="treatyInfo2Label.uwYr" :error-messages="errors.collect('uwYr')" v-validate="'entry'" readonly></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field :label="treatyInfo2Label.dispSeq" v-model="treatyInfo2.dispSeq" item-text="label" item-value="value + label" data-vv-name="dispSeq" :data-vv-as="treatyInfo2Label.dispSeq" :error-messages="errors.collect('dispSeq')" v-validate="'entry'" readonly></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete :items="infoLblList" :label="treatyInfo2Label.infoLbl" v-model="treatyInfo2.infoLbl" item-text="label" item-value="value" data-vv-name="infoLbl" :data-vv-as="treatyInfo2Label.infoLbl" :error-messages="errors.collect('infoLbl')" v-validate="'entry'" @change="doDispSeq($event)" :readonly="this.newMode === false"></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-text-field :label="treatyInfo2Label.infoTxt" v-model="treatyInfo2.infoTxt" item-text="label" item-value="value" data-vv-name="infoTxt" :data-vv-as="treatyInfo2Label.infoTxt" :error-messages="errors.collect('infoTxt')" v-validate="'entry'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-flex lg6 md12 xs12>
            <v-card-actions >
              <v-btn class="white--text error" @click.prevent="doBack">
                Cancel
                <v-icon right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                Save
                <v-icon right>{{newMode? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
              </v-btn>
            </v-card-actions>
          </v-flex>
        </v-expansion-panel-content>
      </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
      </v-layout> -->
      <v-dialog v-model="showMiscTreatyInfo2Detail" width="1000px">
        <v-card>
          <!-- <div slot="header">
            <v-icon>mdi-plus</v-icon>
            {{ newMode ? 'New Miscellaneous Treaty Information 1':'Edit Miscellaneous Treaty Information 1' }}
          </div> -->
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon v-if="newMode">mdi-plus</v-icon>
            <v-icon v-else>mdi-pencil</v-icon>
            <v-toolbar-title v-if="newMode">New Miscellaneous Treaty Information 2</v-toolbar-title>
            <v-toolbar-title v-else>Edit Miscellaneous Treaty Information 2</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <!-- <message :messages="messages"></message> -->
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs3>
                  <v-autocomplete
                    :items="acctTypeList"
                    :label="treatyInfo2Label.riType"
                    v-model="treatyInfo2.riType"
                    item-text="label"
                    item-value="value"
                    data-vv-name="riType"
                    :data-vv-as="treatyInfo2Label.riType"
                    :error-messages="errors.collect('riType')"
                    v-validate="'entry'"
                    @change="initInfoLblList"
                    :disabled="this.newMode === false"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    :label="treatyInfo2Label.ttyNo"
                    v-model="treatyInfo2.ttyNo"
                    item-text="label"
                    item-value="value"
                    data-vv-name="ttyNo"
                    :data-vv-as="treatyInfo2Label.ttyNo"
                    :error-messages="errors.collect('ttyNo')"
                    v-validate="'entry'"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    :label="treatyInfo2Label.uwYr"
                    v-model="treatyInfo2.uwYr"
                    item-text="label"
                    item-value="value"
                    data-vv-name="uwYr"
                    :data-vv-as="treatyInfo2Label.uwYr"
                    :error-messages="errors.collect('uwYr')"
                    v-validate="'entry'"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    :label="treatyInfo2Label.dispSeq"
                    v-model="treatyInfo2.dispSeq"
                    item-text="label"
                    item-value="value + label"
                    data-vv-name="dispSeq"
                    :data-vv-as="treatyInfo2Label.dispSeq"
                    :error-messages="errors.collect('dispSeq')"
                    v-validate="'entry'"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-autocomplete
                    :items="infoLblList"
                    :label="treatyInfo2Label.infoLbl"
                    v-model="treatyInfo2.infoLbl"
                    item-text="label"
                    item-value="value"
                    data-vv-name="infoLbl"
                    :data-vv-as="treatyInfo2Label.infoLbl"
                    :error-messages="errors.collect('infoLbl')"
                    v-validate="'entry'"
                    @change="doDispSeq($event)"
                    :disabled="this.newMode === false"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                    :label="treatyInfo2Label.infoTxt"
                    v-model="treatyInfo2.infoTxt"
                    item-text="label"
                    item-value="value"
                    data-vv-name="infoTxt"
                    :data-vv-as="treatyInfo2Label.infoTxt"
                    :error-messages="errors.collect('infoTxt')"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="doBack">Cancel</v-btn>
            <v-btn color="primary" text @click.native="doSave">Save</v-btn>
          </v-card-actions>
          <!-- <v-flex lg6 md12 xs12>
            <v-card-actions >
              <v-btn class="white--text error" @click.prevent="doBack">
                Cancel
                <v-icon right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
                Save
                <v-icon right>{{newMode? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
              </v-btn>
            </v-card-actions>
          </v-flex> -->
        </v-card>
      </v-dialog>
    </v-container>
    <confirm v-model="promptRemove" @ok="doRemove"> Are you sure to delete the selected RI Type - {{ deleteMiscTreatyInfo2 }} </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { acctType, propNProp } from '@/const/params'
import { expandURI } from '@/utils/ajax'
// import { mapGetters } from 'vuex'
// import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      newMode: true,
      reviewMode: false,
      submitting: false,
      loading: false,
      promptRemove: false,
      showMiscTreatyInfo2Detail: false,
      deleteMiscTreatyInfo2: '',
      selectedMiscTreatyInfo2: undefined,
      miscTreatyInfo2Panel: [false],
      headers: [
        { text: 'RI Type', value: 'riType' },
        { text: 'Proportional / Non-Proportional', value: 'propNProp' },
        { text: 'Display Sequence No.', value: 'dispSeq' },
        { text: 'Information Label', value: 'infoLbl' },
        TableConst.tableActionHeader
      ],
      treatyInfo2Label: {
        riType: 'Inwards / Outwards',
        propNProp: 'Proportional or Non-Proportional',
        ttyNo: 'Treaty Reference',
        uwYr: 'Underwriting Year',
        dispSeq: 'Display Sequence No.',
        infoLbl: 'Information Label',
        infoTxt: 'Information Text',
        newButton: 'New Miscellaneous Treaty Information 2'
      },
      treatyInfo2: {
        riType: undefined,
        ttyNo: undefined,
        uwYr: undefined,
        dispSeq: 0,
        infoLbl: undefined,
        infoLblDesc: undefined,
        infoTxt: undefined,
        propNProp: 'P',
        perPropTty: true,
        perNPropTty: false
      },
      infoLblList: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    doInit() {
      this.treatyInfo2.riType = this.riType
      this.treatyInfo2.ttyNo = this.ttyNo
      this.treatyInfo2.uwYr = this.uwYr
      this.doPropNProp()
      if (this.treatyInfo2.riType !== undefined) {
        this.miscTreatyInfo2Panel = [false]
      }
      this.miscTreatyInfo2List()
      this.initInfoLblList()
    },
    async miscTreatyInfo2List() {
      this.resetMessages()
      const apiURI = this.treatyMenu.miscTreatyInfo2List
      if (apiURI) {
        try {
          this.loading = true
          let expand = {
            riType: this.treatyInfo2.riType,
            ttyNo: this.treatyInfo2.ttyNo,
            uwYr: this.treatyInfo2.uwYr
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.items = []
            const { data } = result.data
            data.map((result) => {
              const convertList = {
                riType: result.riType,
                riTypeDesc: result.riTypeDesc,
                ttyNo: result.ttyNo,
                uwYr: result.uwYr,
                dispSeq: result.dispSeq,
                // infoLbl: result.infoLbl,
                infoTxt: result.infoTxt
              }
              this.items.push(convertList)
            })
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.loading = false
      // const apiURI = this.treatyMenu.miscTreatyInfo2List
      // if (apiURI) {
      //   this.loading = true
      //   const expand = {
      //     riType: this.treatyInfo2.riType,
      //     ttyNo: this.treatyInfo2.ttyNo,
      //     uwYr: this.treatyInfo2.uwYr
      //   }
      //   this.$http.get(expandURI(apiURI, expand)).then(result => {
      //     this.items = []
      //     const { data } = result.data
      //     if (data) {
      //       data.map(result => {
      //         const convertList = {
      //           riType: result.riType,
      //           riTypeDesc: result.riTypeDesc,
      //           ttyNo: result.ttyNo,
      //           uwYr: result.uwYr,
      //           dispSeq: result.dispSeq,
      //           // infoLbl: result.infoLbl,
      //           infoTxt: result.infoTxt
      //         }
      //         this.items.push(convertList)
      //       })
      //     }
      //   }).catch(err => {
      //     this.loading = false
      //     const { data } = err.response
      //     if (data) {
      //       this.message(data)
      //       this.fieldMessage(data)
      //     }
      //   })
      // }
      // this.loading = false
    },
    async initInfoLblList() {
      const apiURI = this.treatyMenu.initInfoLblList
      try {
        const expand = {
          riType: this.treatyInfo2.riType
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (data) {
          this.infoLblList = data
        }
      } catch (err) {
        throw err
      }
    },
    doDispSeq(value) {
      this.treatyInfo2.dispSeq = value
      this.infoLblList.filter(function (item) {
        return item.value === value
      })
      // this.treatyInfo2.infoLbl = selectedObj.label
      // this.treatyInfo2.dispSeq = value
    },
    doPropNProp() {
      if (this.treatyInfo2.propNProp === 'P') {
        this.treatyInfo2.perPropTty = true
        this.treatyInfo2.perNPropTty = false
      } else if (this.treatyInfo2.propNProp === 'N') {
        this.treatyInfo2.perPropTty = false
        this.treatyInfo2.perNPropTty = true
      }
    },
    doNew() {
      this.newMode = true
      this.showMiscTreatyInfo2Detail = true
      this.miscTreatyInfo2Panel = [true]
      this.treatyInfo2.riType = 'O'
      this.treatyInfo2.propNProp = 'P'
      this.treatyInfo2.dispSeq = 0
      this.treatyInfo2.infoLbl = undefined
    },
    doReview(data) {
      this.showMiscTreatyInfo2Detail = true
      this.newMode = false
      this.miscTreatyInfo2Panel = [true]
      this.treatyInfo2.riType = data.riType
      if (data.perNPropTty === true) {
        this.treatyInfo2.propNProp = 'N'
      } else if (data.perPropTty === true) {
        this.treatyInfo2.propNProp = 'P'
      }
      // this.treatyInfo2.propNProp = data.propNProp
      this.treatyInfo2.dispSeq = data.dispSeq
      this.treatyInfo2.infoLbl = data.dispSeq
      this.treatyInfo2.infoTxt = data.infoTxt
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else {
            this.doUpdate()
            // } else if (this.reviewMode) {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedMiscTreatyInfo2 = data
        this.deleteMiscTreatyInfo2 = data.riTypeDesc + ' - Display Sequence - ' + data.dispSeq
      }
    },
    doRemove() {
      const apiURI = this.treatyMenu.deleteMiscTreatyInfo2
      if (apiURI) {
        const expand = this.selectedMiscTreatyInfo2
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.doInit()
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doBack() {
      this.showMiscTreatyInfo2Detail = false
      this.miscTreatyInfo2Panel = [false]
      this.newMode = true
      this.treatyInfo2.riType = 'O'
      this.treatyInfo2.infoLbl = undefined
      this.treatyInfo2.infoTxt = undefined
    },
    async doCreate() {
      const apiURI = this.treatyMenu.createMiscTreatyInfo2
      const form = this.treatyInfo2
      if (apiURI) {
        this.submitting = true
        try {
          // Starts here
          const result = await this.$http.post(apiURI, form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
          this.doInit()
          this.showMiscTreatyInfo2Detail = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.treatyMenu.updateMiscTreatyInfo2
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.treatyInfo2)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          this.doInit()
          this.showMiscTreatyInfo2Detail = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    treatyMenu() {
      return this.$store.state.treatyParam.menu
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function (key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    propNPropList() {
      let result = []
      Object.keys(propNProp).forEach(function (key) {
        const status = propNProp[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
    // ...mapGetters([
    //   'checkAccess'
    // ])
    // riType() {
    //   return this.$route.params.riType
    // },
    // ttyNo() {
    //   return this.$route.params.ttyNo
    // },
    // uwYr() {
    //   return this.$route.params.uwYr
    // }
  },
  created() {
    this.doInit()
  },
  props: ['riType', 'ttyNo', 'uwYr'],
  // props: {
  //   riType: {
  //     type: String,
  //     default: ''
  //   },
  //   ttyNo: {
  //     type: String,
  //     default: ''
  //   },
  //   uwYr: {
  //     type: String,
  //     default: ''
  //   }
  // },
  mixins: [
    TableConst.default,
    MessageMixin
    // routeMixin
  ]
}
</script>
